<template>
  <div class="page-login-v3 layout-full th">
    <div class="page vertical-align text-xs-center" >
      <div class="page-content vertical-align-middle">
        <div class="brand">
          <img class="brand-img" src="/static/images/byteark-loading-white.png" alt="logo account" width="180">
          <h2 class="brand-text font-size-24 grey-100"></h2>
        </div>
        <div class="panel">
          <div class="panel-body panel-form">
            <h3 class="title">{{ $t('forgot.action.forgotPassword') }}</h3>
            <p>{{ $t('forgot.labels.prefixResetPassword') }} <span class="blue-600 text-uppercase">{{$route.params.namespace}}</span> {{ $t('forgot.labels.subfixResetPassword') }}</p>
            <alert v-show="showAlert"
              alertClass="alert-dismissible"
              v-bind:type="`${ (successResponse) ? 'success' : 'danger' }`"
              v-bind:iconClass="`${ (successResponse) ? 'wb-check' : 'wb-close' }`">
              <span v-if="successResponse">{{successResponse}}</span>
              <span v-else-if="errorResponse">{{errorResponse}}</span>
            </alert>
            <form v-on:submit.prevent="onSubmit" v-if="!this.successResponse">
              <div class="user-form">
                <form-group v-bind:error="formErrors.first('email')">
                  <input type="email" class="form-control" id="email" :placeholder="$t('account.labels.email')" v-model="user.email">
                </form-group>
                <button type="submit" class="btn btn-block btn-primary btn-lg btn-submit">{{$t('forgot.action.sendRequest')}}</button>
              </div>
            </form>
            <p class="text-center">{{ $t('action.backTo') }} <u><router-link  v-bind:to="`/${$route.params.namespace}/login`" class="btn btn-link btn-register">{{ $t('action.login') }}</router-link></u></p>
          </div>
        </div>
        <footer class="page-copyright page-copyright-inverse">
          <p>Service by ByteArk.com</p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';
import Alert from 'components/Alert';

export default {
  components: {
    FormGroup,
    Alert,
  },
  watch: {
    'user.email': function() {
      if (this.formErrors.has('email')) {
        this.formErrors.remove('email');
      }
    },
  },
  data: function () {
    return {
      validator: null,
      formErrors: null,
      showAlert: false,
      errorResponse: null,
      successResponse: null,
      user: {
        email: null,
      },
    };
  },
  created: function() {
    this.validator = new Validator({
      email: 'required|email',
    });

    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  methods: {
    onSubmit: function () {
      this.validator.validateAll({
        email: this.user.email,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        const namespace = this.$route.params.namespace;

        axios.post('/api/password/forgot', {
          namespace: namespace,
          email: this.user.email,
        })
        .then(() => {
          this.successResponse = `${this.$t('forgot.response.success')} to ${this.user.email}`;
          this.errorResponse = null;
          this.showAlert = true;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errorResponse = this.$t('forgot.response.failed');
            this.formErrors.addAll(error.response.data);
          } else {
            this.errorResponse = this.$t('forgot.response.defaultFailed');
          }
          this.showAlert = true;
        });
      })
      .catch(() => {
      });
    },
    clearFormErrors() {
      this.formErrors.clear();
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?6f12ce49